
const stateSVGs = {};
stateSVGs.AL = require('assets/images/localnews/alabama.svg');
stateSVGs.AK = require('assets/images/localnews/alaska.svg');
stateSVGs.AZ = require('assets/images/localnews/arizona.svg');
stateSVGs.AR = require('assets/images/localnews/arkansas.svg');
stateSVGs.CA = require('assets/images/localnews/california.svg');
stateSVGs.CO = require('assets/images/localnews/colorado.svg');
stateSVGs.CT = require('assets/images/localnews/connecticut.svg');
stateSVGs.DC = require('assets/images/localnews/maryland.svg');
stateSVGs.DE = require('assets/images/localnews/delaware.svg');
stateSVGs.FL = require('assets/images/localnews/florida.svg');
stateSVGs.GA = require('assets/images/localnews/georgia.svg');
stateSVGs.HI = require('assets/images/localnews/hawaii.svg');
stateSVGs.ID = require('assets/images/localnews/idaho.svg');
stateSVGs.IL = require('assets/images/localnews/illinois.svg');
stateSVGs.IN = require('assets/images/localnews/indiana.svg');
stateSVGs.IA = require('assets/images/localnews/iowa.svg');
stateSVGs.KS = require('assets/images/localnews/kansas.svg');
stateSVGs.KY = require('assets/images/localnews/kentucky.svg');
stateSVGs.LA = require('assets/images/localnews/louisiana.svg');
stateSVGs.ME = require('assets/images/localnews/maine.svg');
stateSVGs.MD = require('assets/images/localnews/maryland.svg');
stateSVGs.MA = require('assets/images/localnews/massachusetts.svg');
stateSVGs.MI = require('assets/images/localnews/michigan.svg');
stateSVGs.MN = require('assets/images/localnews/minnesota.svg');
stateSVGs.MS = require('assets/images/localnews/mississippi.svg');
stateSVGs.MO = require('assets/images/localnews/missouri.svg');
stateSVGs.MT = require('assets/images/localnews/montana.svg');
stateSVGs.NE = require('assets/images/localnews/nebraska.svg');
stateSVGs.NV = require('assets/images/localnews/nevada.svg');
stateSVGs.NH = require('assets/images/localnews/new-hampshire.svg');
stateSVGs.NJ = require('assets/images/localnews/new-jersey.svg');
stateSVGs.NM = require('assets/images/localnews/new-mexico.svg');
stateSVGs.NY = require('assets/images/localnews/new-york.svg');
stateSVGs.NC = require('assets/images/localnews/north-carolina.svg');
stateSVGs.ND = require('assets/images/localnews/north-dakota.svg');
stateSVGs.OH = require('assets/images/localnews/ohio.svg');
stateSVGs.OK = require('assets/images/localnews/oklahoma.svg');
stateSVGs.OR = require('assets/images/localnews/oregon.svg');
stateSVGs.PA = require('assets/images/localnews/pennsylvania.svg');
stateSVGs.RI = require('assets/images/localnews/rhode-island.svg');
stateSVGs.SC = require('assets/images/localnews/south-carolina.svg');
stateSVGs.SD = require('assets/images/localnews/south-dakota.svg');
stateSVGs.TN = require('assets/images/localnews/tennessee.svg');
stateSVGs.TX = require('assets/images/localnews/texas.svg');
stateSVGs.UT = require('assets/images/localnews/utah.svg');
stateSVGs.VT = require('assets/images/localnews/vermont.svg');
stateSVGs.VA = require('assets/images/localnews/virginia.svg');
stateSVGs.WA = require('assets/images/localnews/washington.svg');
stateSVGs.WV = require('assets/images/localnews/west-virginia.svg');
stateSVGs.WI = require('assets/images/localnews/wisconsin.svg');
stateSVGs.WY = require('assets/images/localnews/wyoming.svg');

export default stateSVGs;
